import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { eur } from "@/lib/format";
import { toast } from "sonner";
import { Check, Crown, Loader2 } from "lucide-react";

export default function Upgrade() {
  const { org, loadMe } = useAuth();
  const navigate = useNavigate();
  const [plans, setPlans] = useState(null);
  const [loading, setLoading] = useState("");

  useEffect(() => { api.get("/subscription/plans").then(({ data }) => setPlans(data)); }, []);

  const subscribe = async (plan) => {
    setLoading(plan);
    try {
      await api.post("/subscription/subscribe", { plan });
      toast.success("Abbonamento attivato!");
      await loadMe();
      navigate("/dashboard");
    } catch (e) { toast.error(e?.response?.data?.detail?.message || "Errore"); }
    finally { setLoading(""); }
  };

  const expired = org && org.usable === false;
  const features = ["Immobili illimitati", "Pubblicazione su HolidayWorld", "Borsellino messaggi", "Foglio di viaggio PDF", "Collaboratori delegati", "Supporto prioritario"];

  return (
    <div className="max-w-4xl mx-auto space-y-8 py-4">
      <div className="text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold mb-4"><Crown className="h-3.5 w-3.5" /> {expired ? "Prova scaduta" : "Scegli il tuo piano"}</div>
        <h1 className="font-display text-4xl font-bold tracking-tight">{expired ? "Riattiva il tuo account" : "Passa a un piano completo"}</h1>
        <p className="text-muted-foreground mt-3 max-w-lg mx-auto">{expired ? "Il periodo di prova è terminato. I tuoi dati sono al sicuro — scegli un piano per continuare a gestire i tuoi immobili." : "Sblocca tutte le funzionalità di Mypasspartu."}</p>
      </div>

      {!plans ? <div className="flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div> : (
        <div className="grid md:grid-cols-2 gap-5 max-w-2xl mx-auto">
          {["monthly", "annual"].map((key) => {
            const p = plans[key]; const isPro = key === "annual";
            return (
              <div key={key} className={`rounded-2xl border p-6 relative ${isPro ? "border-primary shadow-xl bg-card" : "border-border bg-card"}`}>
                {isPro && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent text-accent-foreground text-xs font-semibold px-3 py-1 rounded-full">Più conveniente · Pro</span>}
                <h3 className="font-display text-xl font-bold">{p.label}</h3>
                <div className="mt-3 flex items-end gap-1"><span className="font-display text-4xl font-bold">{eur(p.price_cents)}</span><span className="text-muted-foreground text-sm mb-1">/{key === "monthly" ? "mese" : "anno"}</span></div>
                {isPro && <p className="text-xs text-emerald-600 font-medium mt-1">Generazioni AI illimitate</p>}
                <ul className="mt-5 space-y-2.5">
                  {features.map((ft) => <li key={ft} className="flex items-center gap-2 text-sm"><Check className="h-4 w-4 text-primary shrink-0" /> {ft}</li>)}
                </ul>
                <button onClick={() => subscribe(key)} disabled={loading} data-testid={`subscribe-${key}`}
                  className={`w-full mt-6 py-2.5 rounded-lg font-medium transition-all flex items-center justify-center gap-2 ${isPro ? "bg-primary text-primary-foreground hover:opacity-95" : "bg-secondary text-secondary-foreground hover:bg-secondary/80"}`}>
                  {loading === key ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Abbonati con PayPal
                </button>
              </div>
            );
          })}
        </div>
      )}
      <p className="text-center text-xs text-amber-600">⚠️ Pagamento PayPal in modalità DEMO — l'abbonamento si attiva immediatamente senza addebito reale finché non vengono configurate le credenziali PayPal.</p>
      {!expired && <div className="text-center"><button onClick={() => navigate("/dashboard")} className="text-sm text-muted-foreground hover:text-foreground">Torna alla dashboard</button></div>}
    </div>
  );
}
